<template>
    <div class="ft-box">
        <!-- <div class="ft-title aFlex">
            <Icon class="ft-title-mark" type="md-bookmark" />
            <span>月度考勤汇总</span>
        </div> -->
        <div class="calendar">
            <div class="cal-top">
                <span class="cal-title">考勤月度</span>
                <DatePicker type="month" placement="bottom-end" placeholder="请选择"
                            :clearable="false" :options="options" transfer
                            :value="currDate" @on-change="handleDate" ></DatePicker>
                <div style="margin-left: 40px">
                    <div class="aFlex">
                        <div class="cal-dot green" style="margin-right: 10px"></div>正常考勤
                    </div>
                    <div class="aFlex">
                        <div class="cal-dot red" style="margin-right: 10px"></div>未考勤
                    </div>
                </div>
                <div style="margin-left: 44px">
                    <!-- <span v-if="">月度考勤率: 80%</span> -->
                    <span style="color: #ff424a; font-size:20px;">月度考勤率: {{this.rate}}%</span>

                </div>
            </div>
            <div class="cal-box">
                <!-- 星期 -->
                <ul class="cal-weeks">
                    <li class="cal-item">周一</li>
                    <li class="cal-item">周二</li>
                    <li class="cal-item">周三</li>
                    <li class="cal-item">周四</li>
                    <li class="cal-item">周五</li>
                    <li class="cal-item">周六</li>
                    <li class="cal-item">周日</li>
                </ul>
                <!-- 日期 -->
                <ul class="cal-days">
                    <Spin fix v-if="loading"></Spin>
                    <!-- 核心 v-for循环 每一次循环用<li>标签创建一天 -->
                    <li class="cal-item" v-for="(item,index) in days" :key="index">
                        <!-- 不是本月 -->
                        <div v-if="item.otherMonth" >
                            <span class="cal-item-other">{{ item.day}}</span>
                        </div>
                        <!-- 本月 -->
                        <div  v-else class="cal-item-conten">
                            <span>{{ item.day}}</span>
                            <div class="cal-dot" :class="checkType(item.flag)"></div>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
    </div>

</template>
<script>
export default {
  data(){
    return {
      // 日期配置
      options: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      loading:false,
      // 当前日期
      currDate:'',
      // 当前年
      currentYear: 2020,
      // 当前月份
      currentMonth: 2,
      // 当前周数
      currentWeek: 5,
      // 当前日数
      currentDay: 26,
      days: [],
      arrDate: [],
      rate: '',
      // projectId: ''
    };
  },
  watch:{
    dataObj:{
      handler(newVal,oldVal){
        if(newVal){
          this.arrDate = newVal.calendar;
          this.rate = String(newVal.rate) || 0;
          const date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          month = month > 9 ? month : '0' + month;
          this.currDate= this.currDate ? this.currDate : `${year}-${month}`;
          this.initData();
          this.setCheckList();
        }


      },
      deep:true,
      immediate:true
    }
  },
  props: {
    workerId:{
      type: [String,Number]
    },
    // corpId:{
    //     type: [String,Number]
    // },
    dataObj:{
      type:Object,
      default:()=>{}
    },
    // projectId:{
    //     type: [String,Number]
    // },
  },
  computed: {

  },
  created(){
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;
    this.currDate=`${year}-${month}`;
    this.initData();
    this.setCheckList();
    //    this.rate= this.dataObj.rate*100
  },
  mounted(){
  },

  methods: {
    checkType(flag){
      let cstr='';
      if (flag){
        cstr='green';
      }else {
        cstr='red';
      }
      if (flag === 3){
        cstr='gray';
      }
      // switch (type) {
      //     case 1:
      //         cstr='red';
      //         break;
      //     case 2:
      //         cstr='green';
      //         break;
      //     default:
      //         cstr='';
      // }
      return cstr;
    },
    // 日期变化获取考勤列表数据
    getCheckList(){
      this.loading=true;
      this.axios({
        method: 'get',
        url: '/project/workers/oneProjectCalendar',
        params:{
          // workerId:'10344',
          workerId:this.workerId,
          projectId:this.dataObj.projectId,
          // corpId:this.corpId,
          date:this.currDate,
        }
      }).then( (response)=> {
        this.loading=false;
        if (response.data.success){
          this.arrDate=response.data.data[0].calendar;
          this.rate = String(response.data.data[0].rate) || 0;
          this.setCheckList();
        }
      }).catch( ()=> {
        this.loading=false;
      });
    },
    // 日期改变
    handleDate(str){
      this.currDate=str;
      this.getCheckList();
      this.initData();
    },
    initData() {
      let cur=new Date(this.currDate);
      // 月的第一天时间对象
      let firstDate = new Date(this.formatDate(cur.getFullYear(),cur.getMonth() + 1,1));
      // 第一天的年
      this.currentYear = firstDate.getFullYear();
      // 第一天的月
      this.currentMonth = firstDate.getMonth() + 1;
      // 第一天的日数
      this.currentDay = firstDate.getDate();
      // 第一天的星期数
      this.currentWeek = firstDate.getDay(); // 1...6,0
      if (this.currentWeek === 0) {
        this.currentWeek = 7;
      }
      let str = this.formatDate(this.currentYear , this.currentMonth, this.currentDay);
      this.days=[];
      // 第一天的周天数
      for (let i = this.currentWeek - 1; i >= 0; i--) {
        let d = new Date(str);
        d.setDate(d.getDate() - i);
        let day=d.getDate();
        day = day > 9 ? day : '0' + day;
        let dayobject={
          otherMonth:d.getMonth()+1 !== this.currentMonth,
          day:day,
        };
        this.days.push(dayobject);//将日期放入data 中的days数组 供页面渲染使用
      }
      // 剩下的周天数
      for (let i = 1; i <= 42 - this.currentWeek; i++) {
        let d = new Date(str);
        d.setDate(d.getDate() + i);
        let day=d.getDate();
        day = day > 9 ? day : '0' + day;
        let dayobject={};
        dayobject = {
          otherMonth:d.getMonth()+1 !== this.currentMonth,
          day:day,
          flag: false
        };
        this.days.push(dayobject);
      }

    },
    setCheckList () {
      console.log(999,this.arrDate);
      for (let j=0; j<this.days.length; j++){
        for (let i=0; i<this.arrDate.length; i++){
          let currDay=this.currDate+'-'+ this.days[j].day;
          if(this.arrDate[i].date === currDay ){
            console.log(currDay);
            // this.days[j].flag=this.arrDate[i].flag;
            const obj = this.days[j];
            obj.flag = this.arrDate[i].flag;
            if(new Date(this.arrDate[i].date).getTime() > Date.now()) {
              obj.flag = 3;
            }
            this.$set(this.days, j, obj);
            break;
          }

        }
      }
      let raa = this.days.map((item) => {
        return ( item.flag );
      });
      console.log(raa, 'ppppppp');
      console.log(this.arrDate, 'llllllllllllllllllll', this.days);

    },
    // 返回 类似 2016-01-02 格式的字符串
    formatDate(year,month,day){
      let y = year;
      let m = month;
      if(m<10) m = '0' + m;
      let d = day;
      if(d<10) d = '0' + d;
      return y+'-'+m+'-'+d;
    },
  }
};
</script>
<style scoped lang="less">
   .calendar{
        width: 100%;
    }
    .cal-top{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
    }
    .cal-title{
        font-size: 16px;
        color: #333333;
        font-weight: 700;
        margin-right: 20px;
    }
    .cal-dot{
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
    .cal-dot.green{
        background-color: #99CC33;
    }
    .cal-dot.red{
        background-color: #CC3300;
    }
    .cal-dot.gray{
        background-color: #ccc;
    }
    .cal-box{
        border-top: 1px solid #dcdee2;
        border-left: 1px solid #dcdee2;
        position: relative;
        width: 90%;
        margin: auto;
    }
    .cal-weeks,.cal-days{
        display: flex;
        flex-wrap: wrap;
        position: relative;
    }
    /deep/.cal-days .cal-item {
    height: 50px!important;
    }
    /* 每一项 */
    .cal-item{
        width:14.2857% ;
        padding: 10px 5px;
        text-align: center;
        border-right:1px solid #dcdee2;
        border-bottom:1px solid #dcdee2;
    }
    /* 星期 */
    .cal-weeks .cal-item{
        background-color: #F5F5F5;
        font-weight: 700;
        font-size: 14px;
        color: #333333;
    }
    /* 天 */
    .cal-days .cal-item{
        height: 60px;
    }
    .cal-item-conten{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .cal-item-other{
        color: #cccccc;
    }
</style>

